import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    group: '',
    course: '',
    grade_level: '',
    reporter: '',
    student: '',
    created_at_after: '',
    created_at_before: '',
    incident_level_max: '',
    incident_level_min: '',
  },
}

export const behaviorUI = createSlice({
  name: 'behaviorUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    setReporter: (state, { payload }) => {
      state.tableFilters.reporter = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setIncidentLevelMin: (state, { payload }) => {
      state.tableFilters.incident_level_min = payload
    },
    setIncidentLevelMax: (state, { payload }) => {
      state.tableFilters.incident_level_max = payload
    },

    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_after = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_before = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setGroup,
  setCourse,
  setReporter,
  setStudent,
  setIncidentLevelMin,
  setIncidentLevelMax,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  trackActiveFilters,
  clearAllFilters,
} = behaviorUI.actions

export default behaviorUI.reducer
